export enum Reports {
   ExtensionDetail = 'ExtensionDetail',
   ExtensionSummary = 'ExtensionSummary',
   HourlyCallVolume = 'HourlyCallVolume',
   TopCallers = 'TopCallers',
   DailyCallVolume = 'DailyCallVolume',
   WeekDayCallVolume = 'WeekDayCallVolume',
   InternationalCalls = 'InternationalCalls',
   MissedCalls = 'MissedCalls',
   HuntGroupExtension = 'HuntGroupExtension',
   InboundCallsByPhoneNumber = 'InboundCallsByPhoneNumber',
   AbandonedCalls = 'AbandonedCalls',
   SystemInternationalCalls = 'SystemInternationalCalls',
}
